module.exports = __webpack_public_path__ + "static/media/tortilla2.71ac23ad.jpg";